export default interface ProducerAddressInterface {
    addressId: number;
    producerId: number;
    type: AddressType;
    street1: string;
    street2: string;
    city: string;
    state: string;
    postal: string;
}

export enum AddressType {
    Mailing = "FARM",
    Farm = "POUT",
}